import React from 'react'
import TechnologyCard from './TechnologyCard'


const AllTechnologies = ({title, desc, cards}) => {
  return (
      <div className='flex flex-col gap-[40px]'>
          <div className='flex flex-col gap-[16px] font-faustina text-white text-center'>
              <p className=' font-semibold lg:text-[56px] md:text-[40px] xs:text-[clamp(28px,5.2vw,40px)] text-head-gradient '>{title}</p>
              <p className='font-regular lg:text-[20px] xs:text-[clamp(16px,2.7vw,20px)] text-white'>{desc}</p>
          </div>

          {/* ------------------------------------------ Card Component --------------------------------------------------- */}

          <div className='flex justify-center flex-wrap items-center w-full gap-[20px] text-white'>
              {cards?.map((card, i) => (
                  <TechnologyCard
                      img={card.image}
                      heading={card.title}
                  />
              ))}
              
          </div>

          {/* ------------------------------------------ Card Component --------------------------------------------------- */}

    </div>
  )
}

export default AllTechnologies

// import React from 'react'
// import BGImage from '../../assets/images/jpeg/techbg.jpg'
// import PrimaryButton from '../../components/commonComponents/PrimaryButton'
// import AWS from '../../assets/images/svg/aws_logo.svg'
// import DJANGO from '../../assets/images/svg/django_logo.svg'
// import DOCKER from '../../assets/images/svg/docker_logo.svg'
// import EXPRESS from '../../assets/images/svg/express_logo.svg'
// import FLUTER from '../../assets/images/svg/flutter_logo.svg'
// import HF from '../../assets/images/svg/hf_logo.svg'
// import INHOUSE from '../../assets/images/svg/inhouse_logo.svg'
// import Jenkins from '../../assets/images/svg/jenkins_logo.svg'
// import KOTLIN from '../../assets/images/svg/kotlin_logo.svg'
// import langchain from '../../assets/images/svg/langchain-_logo.svg'
// import MicrosoftAzure from '../../assets/images/svg/microsoft_azure_logo.svg'
// import MTEAMS from '../../assets/images/svg/microsoft-teams_logo.svg'
// import MONGO from '../../assets/images/svg/mongo_logo.svg'
// import NEXT from '../../assets/images/svg/next_logo.svg'
// import NODE from '../../assets/images/svg/node_logo.svg'
// import AI from '../../assets/images/svg/openai_logo.svg'
// import PLAYWRITE from '../../assets/images/svg/playwrite_logo.svg'
// import POCKETBASE from '../../assets/images/svg/pocketbase_logo.svg'
// import POSTGRESQL from '../../assets/images/svg/postgresql_logo.svg'
// import QL from '../../assets/images/svg/Qt_logo.svg'
// import REACT from '../../assets/images/svg/react_log.svg'
// import REACTNATIVE from '../../assets/images/svg/react-native_logo.svg'
// import REDUX from '../../assets/images/svg/redux_logo.svg'
// import VITE from '../../assets/images/svg/vite_log.svg'


// const sections = [
//     {
//         title: "Frontend Development",
//         description:
//             "We build responsive, interactive interfaces with fast load times and rich user experiences.",
//         items: ["React.js", "Next.js", "Vite", "Axios, Redux"],
//         itemslogo: [REACT, NEXT, VITE, REDUX]
//     },
//     {
//         title: "Backend Development",
//         description:
//             "Our backend systems are designed for performance, extensibility, and maintainability.",
//         items: ["Node.js with Knex", "Django", "Express.js", "QTpy"],
//         itemslogo: [NODE, DJANGO, EXPRESS,]
//     },
//     {
//         title: "Database Systems",
//         description:
//             "We use a range of relational and NoSQL databases tailored to your data structure and scale.",
//         items: ["MongoDB", "PostgreSQL", "Pocketbase"],
//         itemslogo: []
//     },
//     {
//         title: "Mobile Application Development",
//         description:
//             "We create native and cross-platform mobile apps focused on performance and user engagement.",
//         items: ["React Native", "Kotlin", "Flutter"],
//         itemslogo: []
//     },
//     {
//         title: "Cloud Infrastructure & DevOps",
//         description:
//             "We deploy and manage cloud-native applications with high availability and automation.",
//         items: ["AWS", "Microsoft Azure", "Docker", "Jenkins"],
//         itemslogo: []
//     },
//     {
//         title: "AI & Automation",
//         description:
//             "We’re also equipped to integrate emerging AI technologies into client projects.",
//         items: ["OpenAI", "Hugging Face", "LangChain", "Playwright"],
//         itemslogo: []
//     },
//     {
//         title: "Communication & Project Management",
//         description:
//             "We maintain full transparency and smooth collaboration throughout the project lifecycle.",
//         items: ["Microsoft Teams", "In-house Project Management System"],
//         itemslogo: []
//     },
// ];
// const Technology = () => {



//     return (
//         <>
//             <div style={{ backgroundImage: `url(${BGImage})` }} className='bg-cover bg-center h-[602px] w-full flex justify-center items-center relative overflow-hidden'>

//                 {/* Overlay */}
//                 <div className="absolute inset-0 bg-black/50"></div>
//                 <div className="absolute -top-[47px] -left-[400px] rounded-[50%] bg-dark-slate-blue blur-[300px] size-[800px]"></div>
//                 <div className="absolute -top-[47px] -right-[400px] rounded-[50%] bg-dark-slate-blue blur-[300px] size-[800px]"></div>

//                 <div className='z-50 flex flex-col gap-12'>
//                     <div className='flex flex-col justify-center items-center gap-10'>
//                         <p className='font-sen font-semibold text-white text-[64px]'>Technology Stack</p>
//                         <p className='font-sen font-medium text-white text-[32px] w-[65%] text-center'>Param Group of Companies builds secure, scalable digital solutions using
//                             a full-stack tech approach from UI to AI.</p>
//                     </div>
//                     <div className='w-full flex justify-center'>
//                         <PrimaryButton
//                             title="Get In Touch"
//                             className="bg-white text-dark-slate-blue"
//                         />
//                     </div>
//                 </div>
//             </div>

//             <div className='w-full  flex justify-center'>
//                 <div className='w-[calc(100%-200px)]'>
//                     <div className='flex w-full flex-col gap-20 pt-20'>
//                         <p className='font-normal text-[24px] text-[#676767] font-sen '>At Param Group of Companies, we use a powerful and versatile technology stack to build secure, scalable, and future-ready digital solutions. Our tools and platforms span across all layers of development — from UI design to DevOps, from mobile apps to AI automation — ensuring excellence at every level.</p>
//                         <div className='flex flex-col gap-[60px] w-full items-center '>
//                             {sections?.map((section, index) => (
//                                 <div className='flex flex-col gap-10'>
//                                     <div className='flex flex-col gap-4 text-center'>
//                                         <p className='font-sen text-[60px] font-semibold text-dark-slate-blue'>{section.title}</p>
//                                         <p className='font-sen text-[24px] text-[#676767] '>{section.description}</p>
//                                     </div>
//                                     <div className="flex flex-wrap justify-center gap-4">
//                                         {section.items.map((item, idx) => (
//                                             <div
//                                                 key={idx}
//                                                 className="px-[8%] py-2 text-[#676767] border-1 border-[#E0E0E0] rounded-[15px] drop-shadow-[5px_10px_20px_rgba(124, 124, 124, 0.08)] bg-white font-sen "
//                                             >
//                                                 {item}
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default Technology